



























































































import { Component, Vue } from 'vue-property-decorator';
import axios from '../common/api';
import { ORDER_STATUS } from '../common/const';
import { values } from '../common/domain';
import { day8 } from '../common/utils';

@Component({
    components: {
    },
})
export default class Index extends Vue {
    tab:any = 1
    orders:any[] = []
    day8 = day8
    prodTypes = {
        1:'高级润色',
        2:'原创定制'
    }

    checkedIds:any[] = []

    get allChecked(){
        return this.orders.every(o=>o.status !== 100 || !o.price || o.checked)
    }
    set allChecked(val){
        this.orders.forEach(o=>{
            o.checked = val
        })
    }

    get checkedPrice(){
        let p = 0
        this.checkedIds = []
        this.orders.forEach(o=>{
            if(o.status == 100 && o.price && o.checked){
                p+=o.price
                if(o.is_multi){
                    o.children.forEach(co=>{
                        this.checkedIds.push(co.id)
                    })
                } else {
                    this.checkedIds.push(o.id)
                }
            }
        })
        return p
    }
    
    get displayOrders(){
        if(this.tab === 1){
            return this.orders
        } else {
            return this.orders.filter(o=>o.status > 500 && o.status< 1000)
        }
    }

 

    ORDER_STATUS = ORDER_STATUS
    created(){
        axios.get('/myorders').then(res=>{
            res.data.forEach(o=>{
                if(o.children){
                    o.title = o.group_name + ' ' + o.group_name_en
                } else {
                    o.title = o.product_name + ' ' + o.product_name_en
                }
                
                o.checked = false
                o.opened = false
            })
            this.orders = res.data

        })
    }
  
    setTab(t){
        this.tab = t
    }
    toggleChildren(order){
        order.opened = !order.opened
    }

    gopay(){
        if(this.checkedIds.length){
            values.payingOrderIds = this.checkedIds
            this.$router.push({
                path:'/pay/'+this.checkedPrice,
            })
        }
    }
}
